import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

import { cn } from "./cn";

// 접근성 이름은 고정 aria-label 로 받는다 — aria-labelledby·label 로 묶으면 이름이 비는 접근성 도구가 있어, 바뀌는 상태 글은 aria-describedby 로 단다.
type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & { "aria-label": string };

/** 켜면 바로 저장·적용되는 설정 스위치(설정 › 알림·공개 여부·입금 표시) — 폼 저장 단추와 같이 저장되는 선택은 Checkbox · 켜짐 primary, 꺼짐 input, 손잡이 background, 44×24 · 글은 오른쪽에 두고 `<label className="flex min-h-10 items-center gap-x-2 text-sm" htmlFor=…>` 로 감싸 글을 눌러도 바뀌게 · 글과 aria-label 은 켜진 상태를 말한다(「고객 알림 보내기」, 「알림 끄기」 아님) · 바뀌는 상태 글은 aria-describedby 로. */
const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block size-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
